export const AppPage = {
  flow: 'x',
  width: '100%',
  maxWidth: 'none',
  minWidth: '0',
  margin: '0',
  padding: '0',
  overflow: 'hidden',
  theme: 'document',
  // UI-ADMIN-PAGES-GROUND-1 (Nika 2026-08-18: "since we changed and switched
  // to general root background - you need to fix bg on those related pages
  // too"): every AppPage sits on the ONE ground chain — the active module's
  // `--stage-bg` override, else the design-system stage token — instead of
  // the `document` theme's own opaque surface, which painted OVER the shell
  // root's stage on all ~70 shell pages (admin/* included). Inline `style`,
  // not a theme change: it wins over the theme's class rule, the var() chain
  // is theme-agnostic (canvasBackground.js rule 1), and `theme: 'document'`
  // above still supplies the ink roles. Same paint main.js already carries;
  // a page that genuinely needs the document surface declares its own
  // background (the PageSlot does).
  style: { background: 'var(--stage-bg, var(--color-stage))' },
  '@mobileL': {
    flow: 'y',
    overflowX: 'clip'
  },
  // PageSlot supplies the named container. A split pane can be compact
  // even when the browser is wide; use the same posture as a narrow route.
  '@appMobile': {
    flow: 'y',
    overflowX: 'clip'
  }
}
